#import "../../../../field/fragments/eav-fragment.graphql"

fragment LeadGoalCondition on LeadGoalCondition {
    condition {
        id
        humanReadableObjectiveString
    }
    status
    conditionCustomField {
        ...ConditionCustomField
    }
}

fragment ConditionCustomField on LeadConditionCustomField {
    node {
        ...EntityAttribute
    }
    value {
        ...EntityAttributeValue
    }
    lead {
        id
    }
}
